// Default menu settings configurations

export interface MenuItem {
  title: string;
  icon: string;
  page: string;
  rolename: string;
  isExternalLink?: boolean;
  issupportExternalLink?: boolean;
  badge: { type: string, value: string };
  submenu: {
    items: Partial<MenuItem>[];
  };
  section: string;
}

export interface MenuConfig {
  horizontal_menu: {
    items: Partial<MenuItem>[]
  };
  vertical_menu: {
    items: Partial<MenuItem>[]
  };
}

export const MenuSettingsConfig: MenuConfig = {
  horizontal_menu: {
    items: [
      {
        title: 'Home',
        icon: 'la-home',
        page: '/dashboard/newdashboard',
        rolename: 'Admin,SuperAdmin,Sales,Account',
        submenu: {
          items: [
            {
              title: 'Sales Dashboard',
              page: '/dashboard/newdashboard',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Dashboard',
              page: '/dashboard/sales-dashboard',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            }
          ]
        }
      },
      {
        title: 'Customers',
        icon: 'la-user',
        page: '/customer/customers',
        rolename: 'Admin,SuperAdmin,Sales,Account',
        submenu: {
          items: [
            {
              title: 'Add Quotation',
              page: '/quotation/addquotation',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Quotations',
              page: '/quotation/allquotation',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'New Inward',
              page: '/customer/product-inward',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'New Outward',
              page: '/customer/product-outward',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Inwards',
              page: '/customer/product-inwards',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Outwards',
              page: '/customer/product-outwards',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'New Enquiry',
              page: '/customer/new-enquiry',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Enquiries',
              page: '/customer/enquiries',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            }
          ]
        }
      },
      {
        title: 'Invoice',
        icon: 'icon-book-open',
        page: '/bill/addbill',
        rolename: 'Admin,SuperAdmin,Sales,Account',
        submenu: {
          items: [
            {
              title: 'Add Sale Invoice',
              page: '/bill/addbill',
              rolename: 'Admin,SuperAdmin,Sales,Account',
            },
            {
              title: 'Invoices',
              page: '/bill/allbill',
              rolename: 'Admin,SuperAdmin,Sales,Account',
            },
            {
              title: 'Add Rent & Repair Invoice',
              page: '/rentinvoice/add',
              rolename: 'Admin,SuperAdmin,Sales,Account',
            },
            {
              title: 'Rent & Repair Invoices',
              page: '/rentinvoice/all',
              rolename: 'Admin,SuperAdmin,Sales,Account',
            }
          ]
        }
      },
      {
        title: 'Inventory',
        icon: 'icon-drawer',
        page: '/inventory/addinventory',
        rolename: 'Admin,SuperAdmin,Sales,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Inventory',
              page: '/inventory/addinventory',
              rolename: 'Admin,SuperAdmin,Sales,Hardware',
            },
            {
              title: 'Inventories',
              page: '/inventory/allinventory',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Stock',
              page: '/stock/viewstock',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Add Used Item',
              page: '/stock/add-used-item',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Used Items',
              page: '/stock/all-used-items',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Products',
              page: '/admin/productandmanufacturer',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'Vendors',
              page: '/admin/vendor',
              rolename: 'Admin,SuperAdmin',
            },
          ]
        }
      },
      {
        title: 'Account',
        icon: 'icon-calculator',
        page: '/account/add-purchase-request',
        rolename: 'Admin,SuperAdmin,Account,Sales,Purchase,Hr',
        submenu: {
          items: [
            {
              title: 'New Payment Request',
              page: '/account/add-purchase-request',
              rolename: 'Admin,SuperAdmin,Account,Sales,Purchase',
            },
            {
              title: 'Payment Requests',
              page: '/account/all-purchase-requests',
              rolename: 'Admin,SuperAdmin,Account,Sales,Purchase'
            },
            {
              title: 'Salaries',
              page: '/account/process-employee-salaries',
              rolename: 'SuperAdmin,Account,Hr'
            },
            {
              title: 'Add Expense',
              page: '/admin/addExpense',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            },
            {
              title: 'Expenses',
              page: '/admin/allExpenses',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            }
          ]
        }
      },
      {
        title: 'Challan',
        icon: 'icon-layers',
        page: '/challan/addchallan',
        rolename: 'Admin,SuperAdmin,Sales,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Challan',
              page: '/challan/addchallan',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Challans',
              page: '/challan/allchallan',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            }
          ]
        }
      },
      {
        title: 'Admin',
        icon: 'la-certificate',
        page: '/admin/productandmanufacturer',
        rolename: 'Admin,SuperAdmin',
        submenu: {
          items: [
            {
              title: 'All Stock',
              page: '/admin/allStock',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'System Configuration',
              page: '/masterdata/allmasterdatas',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Clients',
              page: '/admin/clients',
              rolename: 'Admin,SuperAdmin'
            }
          ]
        }
      },
      {
        title: 'Reports',
        icon: 'icon-book-open',
        page: '/report/bill',
        rolename: 'Admin,SuperAdmin,Sales,Account',
        submenu: {
          items: [
            {
              title: 'Invoice Report',
              page: '/report/billsReport',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Sales Report',
              page: '/report/salesReport',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Payments Report',
              page: '/report/payment-report',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Barcode Report',
              page: '/report/product-barcode-report',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            }
          ]
        }
      },
      {
        title: 'Employees',
        icon: 'la-user',
        page: '/employee/employees',
        rolename: 'Admin,SuperAdmin,Account,Hr',
        submenu: {
          items: [
            {
              title: 'Add Leave',
              page: '/admin/addLeave',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            },
            {
              title: 'Leaves',
              page: '/admin/allLeaves',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            },
            {
              title: 'Upload Attendace file',
              page: '/admin/upload-attendance',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            },
            {
              title: 'View Employee Attendance',
              page: '/admin/view-employee-attendance',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            }
          ]
        }
      },
      {
        title: 'Documents',
        icon: 'la-cloud',
        page: '/documents/upload-document',
        rolename: 'Admin,SuperAdmin,Sales,Hardware,Account,Hr',
        submenu: {
          items: [
            {
              title: 'Upload Document',
              page: '/documents/upload-document',
              rolename: 'Admin,SuperAdmin,Sales,Hardware,Account,Hr'
            },
            {
              title: 'Documents',
              page: '/documents/all-documents',
              rolename: 'Admin,SuperAdmin,Sales,Hardware,Account,Hr'
            }
          ]
        }
      },
    ]
  },
  vertical_menu: {
    items: [
      {
        title: 'Home',
        icon: 'la-home',
        page: '/dashboard/newdashboard',
        rolename: 'Admin,SuperAdmin,Sales,Hardware',
        submenu: {
          items: [
            {
              title: 'Sales Dashboard',
              page: '/dashboard/newdashboard',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Dashboard',
              page: '/dashboard/sales-dashboard',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            }
          ]
        }
      },
      {
        title: 'Customers',
        icon: 'la-user',
        page: '/customer/customers',
        rolename: 'Admin,SuperAdmin,Sales,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Quotation',
              page: '/quotation/addquotation',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Quotations',
              page: '/quotation/allquotation',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'New Inward',
              page: '/customer/product-inward',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'New Outward',
              page: '/customer/product-outward',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Inwards',
              page: '/customer/product-inwards',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Outwards',
              page: '/customer/product-outwards',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'New Enquiry',
              page: '/customer/new-enquiry',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Enquiries',
              page: '/customer/enquiries',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            }
          ]
        }
      },
      {
        title: 'Invoice',
        icon: 'icon-book-open',
        page: '/bill/addbill',
        rolename: 'Admin,SuperAdmin,Sales,Account',
        submenu: {
          items: [
            {
              title: 'Add Sale Invoice',
              page: '/bill/addbill',
              rolename: 'Admin,SuperAdmin,Sales,Account',
            },
            {
              title: 'Invoices',
              page: '/bill/allbill',
              rolename: 'Admin,SuperAdmin,Sales,Account',
            },
            {
              title: 'Add Rent & Repair Invoice',
              page: '/rentinvoice/add',
              rolename: 'Admin,SuperAdmin,Sales,Account',
            },
            {
              title: 'Rent & Repair Invoices',
              page: '/rentinvoice/all',
              rolename: 'Admin,SuperAdmin,Sales,Account',
            }
          ]
        }
      },
      {
        title: 'Inventory',
        icon: 'icon-drawer',
        page: '/inventory/addinventory',
        rolename: 'Admin,SuperAdmin,Sales,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Inventory',
              page: '/inventory/addinventory',
              rolename: 'Admin,SuperAdmin,Sales,Hardware',
            },
            {
              title: 'Inventories',
              page: '/inventory/allinventory',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Stock',
              page: '/stock/viewstock',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Add Used Item',
              page: '/stock/add-used-item',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Used Items',
              page: '/stock/all-used-items',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Products',
              page: '/admin/productandmanufacturer',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'Vendors',
              page: '/admin/vendor',
              rolename: 'Admin,SuperAdmin',
            },
          ]
        }
      },
      {
        title: 'Account',
        icon: 'icon-calculator',
        page: '/account/add-purchase-request',
        rolename: 'Admin,SuperAdmin,Account,Sales,Purchase,Hr',
        submenu: {
          items: [
            {
              title: 'New Payment Request',
              page: '/account/add-purchase-request',
              rolename: 'Admin,SuperAdmin,Account,Sales,Purchase',
            },
            {
              title: 'Payment Requests',
              page: '/account/all-purchase-requests',
              rolename: 'Admin,SuperAdmin,Account,Sales,Purchase'
            },
            {
              title: 'Salaries',
              page: '/account/process-employee-salaries',
              rolename: 'SuperAdmin,Account,Hr'
            },
            {
              title: 'Add Expense',
              page: '/admin/addExpense',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            },
            {
              title: 'Expenses',
              page: '/admin/allExpenses',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            }
          ]
        }
      },
      {
        title: 'Challan',
        icon: 'icon-layers',
        page: '/challan/addchallan',
        rolename: 'Admin,SuperAdmin,Sales,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Challan',
              page: '/challan/addchallan',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            },
            {
              title: 'Challans',
              page: '/challan/allchallan',
              rolename: 'Admin,SuperAdmin,Sales,Hardware'
            }
          ]
        }
      },
      {
        title: 'Admin',
        icon: 'la-certificate',
        page: '/admin/productandmanufacturer',
        rolename: 'Admin,SuperAdmin',
        submenu: {
          items: [
            {
              title: 'All Stock',
              page: '/admin/allStock',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'System Configuration',
              page: '/masterdata/allmasterdatas',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Clients',
              page: '/admin/clients',
              rolename: 'Admin,SuperAdmin'
            }
          ]
        }
      },
      {
        title: 'Reports',
        icon: 'icon-book-open',
        page: '/report/bill',
        rolename: 'Admin,SuperAdmin,Sales,Account',
        submenu: {
          items: [
            {
              title: 'Invoice Report',
              page: '/report/billsReport',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Sales Report',
              page: '/report/salesReport',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Payments Report',
              page: '/report/payment-report',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            },
            {
              title: 'Barcode Report',
              page: '/report/product-barcode-report',
              rolename: 'Admin,SuperAdmin,Sales,Account'
            }
          ]
        }
      },
      {
        title: 'Employees',
        icon: 'la-user',
        page: '/employee/employees',
        rolename: 'Admin,SuperAdmin,Account,Hr',
        submenu: {
          items: [
            {
              title: 'Add Leave',
              page: '/admin/addLeave',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            },
            {
              title: 'Leaves',
              page: '/admin/allLeaves',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            },
            {
              title: 'Upload Attendace file',
              page: '/admin/upload-attendance',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            },
            {
              title: 'View Employee Attendance',
              page: '/admin/view-employee-attendance',
              rolename: 'Admin,SuperAdmin,Account,Hr'
            }
          ]
        }
      },
      {
        title: 'Documents',
        icon: 'la-cloud',
        page: '/documents/upload-document',
        rolename: 'Admin,SuperAdmin,Sales,Hardware,Account,Hr',
        submenu: {
          items: [
            {
              title: 'Upload Document',
              page: '/documents/upload-document',
              rolename: 'Admin,SuperAdmin,Sales,Hardware,Account,Hr'
            },
            {
              title: 'Documents',
              page: '/documents/all-documents',
              rolename: 'Admin,SuperAdmin,Sales,Hardware,Account,Hr'
            }
          ]
        }
      },
    ]
  }

};





